import VideoBox from './videobox.vue';
export default VideoBox;


// WEBPACK FOOTER //
// ./src/components/videobox/index.js